export default __webpack_public_path__ + "static/media/pdf_thumbnail_paper.fbf5ece8.jpg";